<template lang="html">
<div class="outlet-detail">
  <row>
    <div class="sl-col-4" v-loading="fullLoading">
      <div class="sl-form">
        <div> <strong>{{label.name}}:</strong>
          <p>{{form.name}}</p>
        </div>
        <div> <strong>{{label.country}}:</strong>
          <p>{{form.country}}</p>
        </div>
        <div> <strong>{{label.state}}:</strong>
          <p>{{form.state}}</p>
        </div>
        <div> <strong>{{label.city}}:</strong>
          <p>{{form.city}}</p>
        </div>
        <div> <strong>{{label.place}}:</strong>
          <p>{{form.address1}} {{form.address2}}</p>
        </div>
        <div> <strong>{{label.lat}}:</strong>
          <p>{{form.lat}}</p>
        </div>
        <div> <strong>{{label.lng}}:</strong>
          <p>{{form.lng}}</p>
        </div>
        <div> <strong>{{label.contact}}:</strong>
          <p>{{form.contact}}</p>
        </div>
        <div> <strong>{{label.phone}}:</strong>
          <p>{{form.phone}}</p>
        </div>
        <strong>{{$t('Views.ViewOutletDetail.table.pt')}}:</strong>
        <div style="height:280px;">
          <el-col :span="12" :xs="24">
            <p>{{$t('Views.ViewOutletDetail.table.p1')}}</p> <img v-if="form.insidePics !== ''" :src="form.insidePics" class="shop-avatar">
            <i v-else class="el-icon-plus shop-uploader-icon"></i>
          </el-col>
          <el-col :span="12" :xs="24">
            <p>{{$t('Views.ViewOutletDetail.table.p2')}}</p>
            <img v-if="form.outsidePics !== ''" :src="form.outsidePics" class="shop-avatar">
            <i v-else class="el-icon-plus shop-uploader-icon"></i>
          </el-col>
        </div>
        <strong>{{$t('Views.AddNewOutlet.form.activeTime')}}:</strong>
        <el-row class="sl-form-box-week" v-for="item in weeks" :key="item">
          <el-col :span="4" :xs="12" class="week-name"> {{item.name}} </el-col>
          <el-col :span="20" :xs="12">
            <el-input auto-complete="off" v-model="item.value" :disabled="true"></el-input>
          </el-col>
        </el-row>
        <router-link tag="el-button" :to="{ name: 'Outlets' }" @click.native="$ga.event('Link', 'Back', 'View store detail')">{{$t('Functional.back')}}</router-link>
      </div>
    </div>
  </row>
</div>
</template>

<script>
import api from '../../../api'
const defaultWeeks = [
  {
    name: 'Monday',
    value: ''
  },
  {
    name: 'Tuesday',
    value: ''
  },
  {
    name: 'Wednesday',
    value: ''
  },
  {
    name: 'Thursday',
    value: ''
  },
  {
    name: 'Friday',
    value: ''
  },
  {
    name: 'Saturday',
    value: ''
  },
  {
    name: 'Sunday',
    value: ''
  }
]
export default {
  name: 'view-outlet',
  created() {
    const vm = this
    api.FetchOutletById(this.$route.params.id).then(res => {
      if (res.data.code === 200) {
        vm.form = res.data.data
        vm.weeks = JSON.parse(vm.form.activeTime)
      }
      vm.fullLoading = false
    })
  },
  computed: {
    label() {
      return {
        name: this.$t('Views.ViewOutletDetail.table.name'),
        place: this.$t('Views.ViewOutletDetail.table.address'),
        country: this.$t('Views.ViewOutletDetail.table.country'),
        state: this.$t('Views.ViewOutletDetail.table.state'),
        city: this.$t('Views.ViewOutletDetail.table.city'),
        lat: this.$t('Views.ViewOutletDetail.table.lat'),
        lng: this.$t('Views.ViewOutletDetail.table.lng'),
        contact: this.$t('Views.ViewOutletDetail.table.contact'),
        phone: this.$t('Views.ViewOutletDetail.table.phone')
      }
    }
  },
  data() {
    return {
      fullLoading: true,
      weeks: defaultWeeks,
      form: {
        name: '',
        phone: '',
        address1: '',
        city: '',
        state: '',
        country: '',
        contact: '',
        lng: '',
        lat: '',
        maplink: '',
        description: '',
        outsidePics: '',
        insidePics: ''
      }
    }
  }
}
</script>
<style>
.upload-photo {
  display: inline-block;
  margin: 0 10px;
  width: 300px;
}

.upload-photo .el-button {
  margin: 0 auto;
}

.upload-photo .el-upload__input {
  display: none;
}

.shop-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 300px;
  height: 200px;
  line-height: 200px !important;
  text-align: center;
  border: 1px dashed #d9d9d9;
}

.shop-avatar {
  width: 300px;
  display: block;
}

.outlet-detail .el-icon-plus:before {
  display: none;
}

.sl-form-box-week {
  padding: 10px 5px;
  border-bottom: none;
}

.sl-form-box-week .week-name {
  font-family: Avenir-Book;
  font-size: 13px;
  color: #9B9B9B;
  letter-spacing: 0;
  line-height: 13px;
  margin-top: 12px;
}
</style>



// WEBPACK FOOTER //
// view-detail.vue?0c37a5b0